document.addEventListener('DOMContentLoaded', function () {
    const capsuleSections = Array.from(document.querySelectorAll('.collection-capsules-list[data-capsules-anchor]'));

    if (!capsuleSections.length) return;

    document.querySelectorAll('[data-capsules-nav]').forEach(function (navEl) {
        const buttons = navEl.querySelectorAll('[data-capsules-nav-button]');

        buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const targetHandle = btn.getAttribute('data-capsules-nav-target');
                if (!targetHandle) return;

                const target = document.querySelector(
                    `.collection-capsules-list[data-capsules-anchor="${targetHandle}"]`
                );
                if (!target) return;

                const rect = target.getBoundingClientRect();
                const offsetTop = rect.top + window.pageYOffset;

                window.scrollTo({
                    top: offsetTop - 80,
                    behavior: 'smooth',
                });
            });
        });
    });
});
